import React, { Component } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";
import { Modal, Header, Close, Footer } from "MODULES/shared/components/Modal";

export default class StatTooltip extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    // This will reset stats when entityId is detected to have changed.
    // Common use-case here is clearing previously loaded company stats when the company is changed to a different company.
    if (nextProps.entityId !== prevState.entityId) {
      return { entityId: nextProps.entityId, statsLoaded: false, stats: {} };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.getTarget = this.getTarget.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.state = {
      entityId: props.entityId,
      statModalOpen: false,
      statsLoaded: false,
      stats: {},
      show: false
    };
  }

  getTarget() {
    return this.target;
  }

  openStatModal = () => {
    this.setState({ show: false, statModalOpen: true });
  };

  closeStatModal = () => this.setState({ statModalOpen: false });

  handleMouseEnter() {
    this.setState({ show: true });

    if (!this.state.statsLoaded) {
      this.props.fetchStats().then(stats => {
        this.setState({ stats, statsLoaded: true });
      });
    }
  }

  handleMouseLeave() {
    this.setState({ show: false });
  }

  render() {
    const { modalTitle, renderStats, renderModal } = this.props;
    const { stats, statModalOpen, show } = this.state;

    return (
      <React.Fragment>
        <Modal
          open={statModalOpen}
          close={this.closeStatModal}
          dialogClass="modal-lg"
        >
          <Header>
            <Close close={this.closeStatModal} />
            <h4 className="modal-title">{modalTitle}</h4>
          </Header>
          <div style={{ margin: 20, marginBottom: 10 }}>
            {renderModal(stats)}
          </div>
          <Footer>
            <button className="btn btn-primary" onClick={this.closeStatModal}>
              Close Stats
            </button>
          </Footer>
        </Modal>
        <i
          onClick={ev => {
            ev.preventDefault();
            ev.stopPropagation();
            this.openStatModal();
          }}
          className="fa fa-info-circle"
          style={{
            cursor: "pointer",
            color: "rgba(255, 255, 255, 0.25)",
            fontSize: 12
          }}
          ref={button => {
            this.target = button;
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        />
        <Overlay target={this.getTarget} show={show} placement="right">
          <Tooltip
            id="stat-tooltip"
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => this.openStatModal()}
            style={{ cursor: "pointer" }}
          >
            {renderStats(stats)}
            <br />
            <a
              onClick={() => this.openStatModal()}
              style={{ cursor: "pointer" }}
            >
              View All Stats
            </a>
          </Tooltip>
        </Overlay>
      </React.Fragment>
    );
  }
}

StatTooltip.propTypes = {
  fetchStats: PropTypes.func.isRequired,
  renderStats: PropTypes.func.isRequired,
  renderModal: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
  entityId: PropTypes.number
};

StatTooltip.defaultProps = {
  modalTitle: "Stats"
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/StatTooltip.jsx